import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { useEffect, useState, useRef } from 'react'
import { LandingPage } from '@/src/components/LandingPage'
import { LocalStorageKey, LocalStorageModel } from '@/storage.config'
import { createSafeStorage } from '@/src/lib/typedStorage'

export const Route = createFileRoute('/')({
  component: HomePage,
  validateSearch: (search: Record<string, unknown>): { force?: boolean } => {
    return {
      force: search.force === true || search.force === 'true' ? true : undefined,
    }
  },
})

function HomePage() {
  const navigate = useNavigate()
  const search = useSearch({ from: '/' })
  const [showLanding, setShowLanding] = useState<boolean | null>(null)
  const hasCheckedRef = useRef(false)

  useEffect(() => {
    // Prevent double-check in StrictMode
    if (hasCheckedRef.current) return
    hasCheckedRef.current = true

    const storage = createSafeStorage<LocalStorageModel>(() => window.localStorage)
    const hasVisited = storage.get(LocalStorageKey.HasVisited)

    // If force parameter is present, always show landing page
    if (search.force) {
      storage.set(LocalStorageKey.HasVisited, true)
      setShowLanding(true)
    } else if (hasVisited) {
      // Returning user - redirect to upload page
      navigate({ to: '/upload' })
    } else {
      // New user - show landing page and mark as visited
      storage.set(LocalStorageKey.HasVisited, true)
      setShowLanding(true)
    }
  }, [navigate, search.force])

  // Don't render anything until we determine if user has visited
  if (showLanding === null) {
    return null
  }

  return <LandingPage />
}
